const newReducers = [
  'axisIntervals',
  'annotations',
  'legend',
  'headings',
  'data',
  'econdata',
  'plotBands',
  'plotLines',
];

function convertItem(data, item) {
  const {
    // axisIntervals
    mobileXAxisInterval,
    mobileXAxisIntervalSameAsDesktop,
    xAxisInterval,
    yAxisInterval,
    yAxisMobileEnabled,
    yAxisMobileInterval,
    logScale,
    allowDecimals,
    majorTicksArticle,
    minorTicksArticle,
    majorTicksPrint,
    minorTicksPrint,
    majorTicksPromo,
    minorTicksPromo,
    minorLabelsVisible,
    hiddenCategoriesArticle,
    hiddenCategoriesPrint,
    hiddenCategoriesPromo,
    quarterlyResults,
    // annotations
    items,
    // legend
    enabled,
    layout,
    showColorChips,
    itemsInOrder,
    // headings
    title,
    dek,
    subdek,
    note,
    source,
    date,
    xaxisTitle,
    yaxisTitle,
    slug,
    subdekPromo,
    notePromo,
    sourcePromo,
    chartFont,
    altText,
    // data
    dataPanelType,
    firstRowAsNames,
    firstColumnAsCategories,
    removeOverlappingCategories,
    allowCategoriesLinebreak,
    categoriesAreDates,
    categoriesAreMonthly,
    fiscalYears,
    irregularDates,
    reverseDateMonth,
    sheetsUrl,
    sheetsLastUpdated,
    sheetsError,
    sheetName,
    sheetNames,
    firstCell,
    lastCell,
    dataSource,
    spreadLink,
    dataNotes,
    logScaleAllowed,
    // econdata
    fredSeries,
    fredFrequency,
    fredStart,
    fredEnd,
    fredUnits,
    fredMoving,
    fredMethod,
    blsPreset,
    blsSeries,
    blsStart,
    blsEnd,
    blsCalculations,
    blsMonths,
    blsMoving,
    showBLSMessage,
    blsError,
    // plotLines
    plotLines,
    // plotBands
    plotBands,
    plotBandPresets,
    showUkRecessions,
    showUsRecessions,
  } = data;

  switch (item) {
    case 'axisIntervals':
      return {
        mobileXAxisInterval: mobileXAxisInterval || '',
        mobileXAxisIntervalSameAsDesktop,
        xAxisInterval,
        yAxisInterval,
        yAxisMobileEnabled,
        yAxisMobileInterval,
        logScale,
        allowDecimals,
        majorTicksArticle,
        minorTicksArticle,
        majorTicksPrint,
        minorTicksPrint,
        majorTicksPromo,
        minorTicksPromo,
        hiddenCategoriesArticle: hiddenCategoriesArticle || [],
        hiddenCategoriesPrint: hiddenCategoriesPrint || [],
        hiddenCategoriesPromo: hiddenCategoriesPromo || [],
        minorLabelsVisible,
        quarterlyResults,
      };
    case 'annotations':
      return { items };
    case 'legend':
      return {
        enabled,
        layout,
        showColorChips,
        itemsInOrder,
      };
    case 'headings':
      return {
        title,
        dek,
        subdek,
        note,
        source,
        date,
        xaxisTitle,
        yaxisTitle,
        slug,
        subdekPromo,
        notePromo,
        sourcePromo,
        chartFont: chartFont || 'en',
        altText,
      };
    case 'data':
      return {
        firstRowAsNames,
        firstColumnAsCategories,
        removeOverlappingCategories,
        allowCategoriesLinebreak,
        categoriesAreDates,
        categoriesAreMonthly,
        fiscalYears,
        irregularDates,
        reverseDateMonth,
        dataPanelType,
        sheetsUrl,
        sheetsLastUpdated,
        sheetsError,
        sheetName,
        sheetNames,
        firstCell,
        lastCell,
        dataSource,
        spreadLink,
        dataNotes,
        logScaleAllowed,
      };
    case 'econdata':
      return {
        fredSeries: fredSeries || [],
        fredFrequency,
        fredStart,
        fredEnd,
        fredUnits,
        fredMoving,
        fredMethod,
        blsPreset,
        blsSeries: blsSeries || [],
        blsStart,
        blsEnd,
        blsCalculations,
        blsMonths,
        blsMoving,
        showBLSMessage,
        blsError,
      };
    case 'plotLines':
      return { plotLines };
    case 'plotBands':
      return { plotBands, plotBandPresets, showUkRecessions, showUsRecessions };
    default: {
      throw new Error(`Conversion failed for ${item} with data: ${JSON.stringify(data, null, 2)}`);
    }
  }
}

function convertAll(data, ...args) {
  return args.map((arg) => convertItem(data, arg));
}

function createObj(data, ...args) {
  return args.reduce((obj, arg) => Object.assign(obj, { [arg]: convertItem(data, arg) }), {});
}

function extractProps(props) {
  return newReducers.map((prop) => props[prop]);
}

export { newReducers, convertAll, createObj, extractProps };
